<template>
  <Teleport to="body">
    <div
      v-show="isShown"
      :ref="popoverElementRef"
      v-bind="$attrs"
      role="dialog"
      :aria-label="ariaLabel"
      class="popover fixed z-[60] flex max-h-[calc(100vh-32px)] w-[320px] max-w-[calc(100vw-32px)] flex-col gap-3 overflow-y-auto rounded-2xl border border-app-grey-light bg-white p-4 shadow"
    >
      <slot />
    </div>
  </Teleport>
</template>

<script setup lang="ts">
import type { PopoverProps } from '@design-system/common/application/component/Popover/Popover.types';

defineOptions({ inheritAttrs: false });
defineProps<PopoverProps>();
</script>
